// images reducer
const SET_IMAGES = 'SET_IMAGES'

function images(state=[], action) {
	switch(action.type) {
		case SET_IMAGES:
			return action.images
		default:
			return state
	}
}

function setImagesAction(_images) {
	return {
		type: SET_IMAGES,
		images: _images
	}
}

export { images, setImagesAction }



// WEBPACK FOOTER //
// ./src/reducers/images.js